module.exports = __webpack_public_path__ + "img/dress4.c6333386.jpeg";